import {
  IChallenge,
  IChallengeDetail,
  IChallengeInfo,
  IChallengeLeaderboardItem
} from '../../../interfaces/challenges';
import { MOCK_GET_CHALLENGES_INFO, MOCK_GET_COMPANY_CHALLENGES, MOCK_GET_LEADERBOARD } from '../../../mocks/challenges';
import { DEFAULT_CUSTOM_RESPONSE_MOCK } from '../../../mocks/customResponse';
import { HttpServiceServer } from '../../http/httpService';

export class Challenges {
  static async getCompanyChallenges(companyId: string, status?: string): Promise<IChallengeDetail[]> {
    const response = await HttpServiceServer.get<IChallengeDetail[]>(
      `companies/${companyId}/challenges/`,
      { params: { status } },
      { data: MOCK_GET_COMPANY_CHALLENGES }
    );
    return response.data;
  }

  static async getLeaderboard(
    companyId: string,
    leaderboardId: string,
    limit: number,
    offset: number
  ): Promise<IChallengeLeaderboardItem[]> {
    const response = await HttpServiceServer.get<IChallengeLeaderboardItem[]>(
      `companies/${companyId}/challenges/leaderboards/${leaderboardId}?limit=${limit}&offset=${offset}`,
      {},
      { data: MOCK_GET_LEADERBOARD }
    );
    return response.data;
  }

  static async getChallengesInfo(): Promise<IChallengeInfo[]> {
    const response = await HttpServiceServer.get<IChallengeInfo[]>(
      '/companies/challenges/get-challenges-info',
      {},
      { data: MOCK_GET_CHALLENGES_INFO }
    );
    return response.data;
  }

  static async updateChallenges(challengeId: string): Promise<void> {
    await HttpServiceServer.patch(
      '/companies/challenges/update-challenge-status/',
      { challengeId },
      {},
      DEFAULT_CUSTOM_RESPONSE_MOCK
    );
  }

  static async postChallenge(companyId: string, challenge: IChallenge): Promise<void> {
    await HttpServiceServer.post(`companies/${companyId}/challenges`, challenge, {}, {});
  }
}

export default Challenges;
